export const matchesPermission = (permission, search) =>
    [permission.name, permission.label].some((value) =>
        (value || '').toLocaleLowerCase().includes(search.trim().toLocaleLowerCase()));

export const permissionTitle = (permission) => {
    const title = permission.label || permission.name || 'Unnamed permission';
    return title.charAt(0).toLocaleUpperCase() + title.slice(1);
};

export const hasDistinctLabel = (permission) => !!permission.label &&
    permission.label.trim().toLocaleLowerCase() !== (permission.name || '').trim().toLocaleLowerCase();
